import { DesignUpload } from '@/types';
import { getParams } from '@/utils/params';
import { postToDesignerService } from './fetchFromDesignerService';

interface SpecialFontTaskPayload {
  size: string;
  fontId: string;
  align: string;
  text: string;
}

export const createPimpFontTask = (payload: SpecialFontTaskPayload) =>
  postToDesignerService<{ id: string; url: string }>('fonts/tasks', payload);

export const createPimpFontDesign = (taskId: string, fontId: string, align: string, text: string) =>
  postToDesignerService<DesignUpload>(`fonts/tasks/${taskId}/designs`, {
    fontId,
    text,
    align,
    shopId: getParams().contextId,
  });
